export default "__VITE_ASSET__TY78tpC2__"